import React from 'react';

import { AlertInfo } from '@ad-scripts/presentation/components/common/alert';
import { Button } from 'src/presentation/components/agent_desktop_components';
import { convertSecondsToMinutes } from 'src/presentation/components/pages/shared/utils/TimeUtils';
import { EndpointTypes } from 'src/models/Channels/endpointType';
import { formatPhone } from 'src/actions/shared/phonesHelper';
import { getAdminURL } from 'src/presentation/components/pages/shared/utils/Utils';
import { H3 } from '@ad-scripts/presentation/components/common/headers';
import {
  StepWizardActionContainer,
  StepWizardFieldWithBorder,
} from 'src/presentation/components/pages/email/components/StepWizardLayout';
import {
  StyledBold,
  StyledDescription,
  StyledLink,
} from 'src/presentation/components/pages/channels/shared/setupPhoneModal/templates/shared/elements';
import useDefaultConfiguration from 'src/presentation/components/pages/channels/shared/hooks/useDefaultConfiguration';

const SetEntryPoint = ({ nextStep, phoneNumber }: { nextStep?; phoneNumber: string }): JSX.Element | null => {
  return <EntryPoints nextStep={nextStep} phoneNumber={phoneNumber} />;
};

const EntryPoints = ({ nextStep, phoneNumber }: { nextStep?; phoneNumber: string }) => {
  const { inboxName, slaSeconds } = useDefaultConfiguration(EndpointTypes.VOICE);

  return (
    <>
      <StepWizardFieldWithBorder>
        <H3 data-aid="wizard-title">Review Entry Point</H3>
        <StyledDescription>
          By default, all inbound voice calls for <StyledBold>{formatPhone(phoneNumber)}</StyledBold> will be routed to{' '}
          <StyledBold>{inboxName}</StyledBold> with an SLA of{' '}
          <StyledBold>{convertSecondsToMinutes(slaSeconds)}</StyledBold> minutes.
        </StyledDescription>
        <AlertInfo>
          <b>Note:&nbsp;</b>
          <StyledLink target="_blank" rel="noopener noreferrer" href={getAdminURL('entry-points')}>
            Go to Entry Points
          </StyledLink>
          , if you want to link this number to a different Inbox
        </AlertInfo>
      </StepWizardFieldWithBorder>
      <StepWizardActionContainer>
        <Button data-aid="editor-save" type={Button.Types.PRIMARY} onClick={nextStep}>
          Next
        </Button>
      </StepWizardActionContainer>
    </>
  );
};

export default SetEntryPoint;
